import UserEdit from "./edit.vue";
import UserList from "./list.vue";
import recordList from "./recordlist.vue";
import UserEditPassword from "./edit/password.vue";
import squadList from "./squad/list.vue";
import squadEdit from "./squad/edit.vue";
import accountList from "./account/list.vue";
let a = Object.assign({
  UserEdit,
  UserList,
  UserEditPassword,
  recordList,
  squadList,
  squadEdit,
  accountList,
});
export default a;
